module.exports = __webpack_public_path__ + "static/img/32-2.b66ffac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/32-2.jpg
// module id = oIS7
// module chunks = 0